import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type IntegrationProblemType as SchemaIntegrationProblemType } from '../schemas/IntegrationProblemType';
import { type IntegrationType as SchemaIntegrationType } from '../schemas/IntegrationType';
import { type Problem as SchemaProblem } from '../schemas/Problem';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const StartMappingIntegrationContentType = '' as const;
export type StartMappingIntegrationRequest = void;
export type StartMappingIntegrationResponses = LinkCommonErrorResponses & {
    /**
     * @description Product mapping started successfully
     */
    '200': {};
    /**
     * @description Invalid input or validation error
     */
    '400': {
        'application/json': SchemaProblem & {
            type: SchemaIntegrationProblemType;
        };
    };
};
export type StartMappingIntegrationResponseSuccess = undefined;
export type StartMappingIntegrationSearchParams = undefined;
export type StartMappingIntegrationPathParameters = {
    integration_type: SchemaIntegrationType;
};
export const StartMappingIntegrationUrl = '/integrations/mapping/{integration_type}/start' as const;
export const StartMappingIntegrationMethod = 'POST' as const;
export const getStartMappingIntegrationUrl = (params: StartMappingIntegrationPathParameters) =>
    StartMappingIntegrationUrl.replace(/\{(\w+)\}/g, (_match, param: keyof StartMappingIntegrationPathParameters) =>
        String(params[param])
    );
